import api from "api/api";

export const getProfileList = async () => await api.get("/settings/profile");

export const getProfileById = async (id) =>
  await api.get(`/settings/profile/${id}`);

export const createProfile = async (data) =>
  await api.post(`/settings/profile/`, data);

export const updateProfileById = async (id, data) =>
  await api.put(`/settings/profile/${id}`, data);

export const deleteProfileById = async (id) =>
  await api.delete(`/settings/profile/${id}`);
